<template>
    <div>
        <v-dialog v-model="mostra" width="600" persistent>
            <v-toolbar color="primary" dense dark>
                <v-row align="center">
                    <v-col cols="5" align="left">
                        <v-toolbar-title>Scansione di rete</v-toolbar-title>
                    </v-col>
                    <v-col align="center" cols="2">
                        <v-btn small light @click="nmapScan">
                            <v-icon color="success">mdi-send</v-icon>
                        </v-btn>
                    </v-col>
                    <v-col cols="5" align="right">
                        <v-btn small light @click="chiudiDialog">
                            <v-icon color="red">mdi-close</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
            </v-toolbar>
            <v-card>
                <v-container>
                    <v-row>
                        <v-col cols="6">
                            <v-text-field
                                dense
                                v-model="range_ip"
                                label="Range IP"
                            />
                        </v-col>
                        <v-col cols="6">
                            <v-text-field
                                dense
                                v-model="range_porte"
                                label="Range porte"
                            />
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
        </v-dialog>

        <v-dialog persistent v-model="result.mostra" width="600">
            <v-card>
                <v-toolbar color="primary" dense dark>
                    <v-toolbar-title>Rislutato scansione</v-toolbar-title>
                    <v-spacer />
                    <v-btn small light @click="result.mostra = false">
                        <v-icon color="red">mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-container v-if="result.data != null">
                    <div
                        style="max-height: calc(100vh - 150px); overflow: auto"
                    >
                        <v-treeview
                            hoverable
                            :items="result.data"
                            dense
                            item-key="__uid"
                            v-model="result.opened"
                        >
                            <template v-slot:prepend="{ item }">
                                <!-- MAIN -->
                                <div v-show="item._type == 'main'">
                                    <p class="my-2">
                                        <strong>Host totali:</strong>
                                        {{ item.total }}
                                    </p>
                                    <p class="my-2">
                                        <strong>Host UP:</strong> {{ item.up }}
                                    </p>
                                    <p class="my-2">
                                        <strong>Host DOWN:</strong>
                                        {{ item.down }}
                                    </p>
                                </div>

                                <!-- HOST -->
                                <div v-show="item._type == 'host'">
                                    <p class="my-2">
                                        <strong>IP:</strong>
                                        {{ item.ip_address }}
                                    </p>
                                    <p class="my-2">
                                        <strong>Tipologia IP:</strong>
                                        {{ item.ip_address_type }}
                                    </p>
                                    <p
                                        class="my-2"
                                        :set="
                                            (icon = getHostStateIcon(
                                                item.status
                                            ))
                                        "
                                    >
                                        <strong>Stato:</strong>
                                        <v-icon :color="icon.color">{{
                                            icon.icon
                                        }}</v-icon>
                                    </p>
                                </div>

                                <!-- PORT -->
                                <div v-show="item._type == 'port'">
                                    <p class="my-2">
                                        <strong>Numero porta:</strong>
                                        {{ item.port_number }}
                                    </p>
                                    <p class="my-2">
                                        <strong>Tipologia porta:</strong>
                                        {{ item.ip_protocol }}
                                    </p>
                                    <p
                                        class="my-2"
                                        :set="
                                            (icon = getPortStateIcon(
                                                item.state
                                            ))
                                        "
                                    >
                                        <strong>Stato:</strong>
                                        <v-icon :color="icon.color">{{
                                            icon.icon
                                        }}</v-icon>
                                    </p>
                                    <p class="my-2">
                                        <strong>Servizio standard:</strong>
                                        {{ item.service }}
                                    </p>
                                </div>
                            </template>
                        </v-treeview>
                    </div>
                </v-container>
            </v-card>
        </v-dialog>
        <SnackbarQV ref="SnackbarQV" />
    </div>
</template>
<script>
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";
export default {
    name: "DialogScansioneRete",
    components: {
        SnackbarQV,
    },
    props: {},
    data: () => ({
        id_dispositivo: null,
        NETWORK: null,
        mostra: false,
        range_ip: null,
        range_porte: null,
        result: {
            mostra: false,
            data: null,
            opened: [1],
        },
    }),
    methods: {
        apriDialog(device_id) {
            this.id_dispositivo = device_id;
            this.mostra = true;
        },
        chiudiDialog() {
            this.mostra = false;
            this.range_ip = null;
            this.range_porte = 1;
        },
        getHostStateIcon(state) {
            switch (state) {
                case "up":
                    return { icon: "mdi-check-network", color: "success" };
                case "down":
                    return { icon: "mdi-close-network", color: "error" };
                default:
                    return { icon: "mdi-minus-network", color: "orange" };
            }
        },
        getPortStateIcon(state) {
            switch (state) {
                case "open":
                    return { icon: "mdi-check", color: "success" };
                case "closed":
                    return { icon: "mdi-close", color: "error" };
                case "filtered":
                    return { icon: "mdi-ghost", color: "primary" };
                default:
                    return { icon: "mdi-help-circle-outline", color: "orange" };
            }
        },
        nmapScan() {
            const that = this;
            const request = {
                controller: "quickconnext",
                endpoint: "connext",
                response: { parse: false },
                showdialog: false,
                body: {
                    action: "nmapscan",
                    token: localStorage.user_token,
                    id_dispositivo: this.id_dispositivo,
                    range_ip: this.range_ip,
                    range_porte: this.range_porte,
                },
                method: "PUT",
                on: {
                    load: function (response) {
                        response = JSON.parse(response);
                        let uid = 0;

                        const result = response.hosts;
                        result.children = result.detail;
                        result._uid = ++uid;
                        result._type = "main";
                        delete result.detail;

                        result.children.forEach((host) => {
                            host.children = host.ports;
                            host._uid = ++uid;
                            host._type = "host";
                            delete host.ports;
                            if (
                                host.children != null &&
                                typeof host.children != "undefined"
                            ) {
                                host.children.forEach((port) => {
                                    port._uid = ++uid;
                                    port._type = "port";
                                });
                            }
                        });
                        that.result.data = [result];
                        that.result.mostra = true;
                        that.result.opened = [1];
                    },
                    error: function (err) {
                        that.$refs.SnackbarQV.print(
                            "error",
                            err.srcElement.responseText
                        );
                    },
                },
            };
            this.NETWORK.AjaxRequest(request);
        },
    },
    mounted() {
        this.NETWORK = this.$store.state.Network;
    },
};
</script>
